<template>
  <div class="car-type">
    <div class="row">
      <div class="col-sm-6">
        <h4>{{ carType.variety }}</h4>
        <p>{{ carType.make }} {{ carType.model }}</p>
        <p><strong>Year</strong> {{ carType.year }}</p>
      </div>
      <div class="col-sm-6">
        <p v-if="carType.CarClass">
          <strong>Vehicle Class: </strong>
          <span class="label" :class="randomLabel">
            {{ carType.CarClass.name }}
          </span>
        </p>
        <p>
          <strong>Cars in Fleet: </strong>
          {{ carType.CarsCount }}
        </p>
        <img :src="carImage"/>
      </div>
    </div>
    <div class="toolbar text-right">
      <router-link class="btn btn-default"
            :to="{ path: `/fleet/vehicles/types/edit/${carType.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarType',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    carImage () {
      return 'https://techcar-dev.s3.amazonaws.com/' +
      this.carType.AmazonImage.objectKey
    },
    randomLabel () {
      if (this.carType.CarClass) {
        let num = this.carType.CarClass.name.charCodeAt(0)
        return {
          'badge-success': num % 5 === 0,
          'badge-primary': num % 5 === 1,
          'badge-danger': num % 5 === 2,
          'badge-info': num % 5 === 3,
          'badge-warning': num % 5 === 4
        }
      } else {
        return {}
      }
    },
    carType () {
      return {
        AmazonImage: {},
        CarClass: {},
        ...this.object
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/CarType.vue